import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map, flatMap } from 'rxjs/operators';

import { BaseService, AppSettingsService, AuthenticationService, ServiceManager } from 'iui-iconectiv-lib';
import { GenericResponse } from '../shared';

export class SearchResponse extends GenericResponse {
  searchResponse: any;
}

@Injectable()
export class SearchService extends BaseService {

  constructor(
    serviceManager: ServiceManager,
    private http: HttpClient,
    private appSettings: AppSettingsService,
    private authService: AuthenticationService,
  ) {

    super(serviceManager);

  }


  getServer(settings: any) {
    if (Array.isArray(settings.servers)) {
      const len = settings.servers.length;
      const idx = Math.floor(Math.random() * len);
      //console.log("server: "+ settings.servers[idx]);
      return settings.servers[idx];
    }
    else {
      return '';
    }
  }

  getCsv(path: string): Observable<any> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + path;

      return this.http.get(url, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('Authorization', this.authService.getToken()),
        responseType: 'text'
      });
    })));
  }

  getJson(path: string): Observable<SearchResponse> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + path;

      return this.http.get<SearchResponse>(url, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('Authorization', this.authService.getToken())
      });
    })));
  }

  postCsv(path: string, json: string): Observable<any>  {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + path;

      return this.http.post(url,
        json, {
          headers: new HttpHeaders()
            .append('Content-Type', 'application/json')
            .append('Authorization', this.authService.getToken()),
          responseType: 'text'
        });
    })));
  }

  postJson(path: string, json: string): Observable<SearchResponse> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + path;

      return this.http.post<SearchResponse>(url,
        json,
        {
          headers: new HttpHeaders()
            .append('Content-Type', 'application/json')
            .append('Authorization', this.authService.getToken())
        });
    })));
  }

  // retrieve Code data
  getCodeData(code: string, resultsType?: string): Observable<any> {
    return (resultsType === 'csv')
      ? this.getCsv('/api/search/csv/code/' + code)
      : this.getJson('/api/search/code/' + code);
  }

  // retrieve NPB data
  getNpbData(npb: string, resultsType?: string, includeHistory?: boolean): Observable<any> {
    return (resultsType === 'csv')
    ? this.getCsv('/api/search/csv/npb/' + npb + "?includeHistory="+ includeHistory)
    : this.getJson('/api/search/npb/' + npb);
  }

  // retrieve TN Range data
  getTnRangeData(tnRange: string, resultsType?: string, includeHistory?:boolean): Observable<any> {
    return (resultsType === 'csv')
    ? this.getCsv('/api/search/csv/tn-range/' + tnRange + "?includeHistory="+ includeHistory)
    : this.getJson('/api/search/tn-range/' + tnRange);
  }

  // retrieve TN List data - supports TN and TN File search
  getTnListData(tnListJson: string, inputType: string, resultsType?: string, includeHistory?:boolean): Observable<any> {
    const request = (inputType === 'byTns') ? 'tn-list' : 'tn-file';

    return (resultsType === 'csv')
    ? this.postCsv('/api/search/csv/' + request + "?includeHistory="+ includeHistory, tnListJson)
    : this.postJson('/api/search/' + request, tnListJson);
  }


}
